<div class="modal-header">
    <label class="col-form-label" style="font-weight: bold;">Modificar interlocutor comercial "{{objCliente.codcli}} -
        {{objCliente.razonc}}"</label>
    <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
        tabindex="13">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-lg-12">

            <div>
                <button [disabled]="encontro" tabindex="22" type="button" class="btn btn-rounded btn-info m-b-15"
                    (click)="modificarCliente()"><i class="fa fa-save"></i>
                    Guardar </button>
                <button tabindex="22" type="button" class="btn btn-rounded btn-danger m-b-15"
                    (click)="eliminarCliente()" [hidden]="objCliente.codcli == null || objCliente.dident == null"><i
                        class="fa fa-trash"></i>
                    Eliminar </button>
                <button (keydown.tab)="onNexFocus('Insert')" tabindex="23" type="button"
                    class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()"><i
                        class="fa fa-times-circle"></i>
                    Cancelar </button>
            </div>


            <div class="card">
                <div class="card-body">
                    <div [hidden]="vista !== 1">
                        <ngb-tabset>

                            <ngb-tab title="Interlocutor comercial">

                                <ng-template ngbTabContent>
                                    <div class="card-body">

                                        <button class="btn btn-outline-dark" routerLinkActive="active"
                                            (click)="importarDatosSunat()" id="btnImportar"><img
                                                src="./assets/img/Sunat.ico"
                                                style="width: 16px;height: 16px;margin-left: -.5rem" />Importar de
                                            SUNAT</button>
                                        <div class="row">
                                            <div class="col-md-12">

                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">

                                                    <label class="col-md-2 label-size tsiLabel mt-2"></label>


                                                    <div class="col-sm-6">
                                                        <label class="ui-radio">
                                                            <input type="radio" value="0"
                                                                (change)="onChangeRadioButron()"
                                                                [(ngModel)]="tipobusqueda" name="tipo">
                                                            <span class="input-span"></span> Nombre
                                                        </label>

                                                        <label class="ui-radio" style="margin-left: 25px;">
                                                            <input type="radio" value="1"
                                                                (change)="onChangeRadioButron()"
                                                                [(ngModel)]="tipobusqueda" name="tipo">
                                                            <span class="input-span"></span> Razón social
                                                        </label>
                                                    </div>

                                                </div>

                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">

                                                    <label class="col-md-2 label-size tsiLabel mt-2">Interlocutor
                                                        comercial:</label>


                                                    <div class="col-sm-2">
                                                        <input type="text"
                                                            class="focus-input input_border focus-input input_border form-control   tsiInput mr-2"
                                                            name="desInterlocutor" [(ngModel)]="objCliente.codcli"
                                                            [disabled]="disabledInterlocutor" tabindex="5"
                                                            data-toggle="tooltip" data-placement="top"
                                                            title="MÁXIMO DE 20 CARACTERES"
                                                            data-original-title="MÁXIMO DE 20 CARACTERES"
                                                            (keydown.enter)="onKeyEnterCodInterlocutor($event)"
                                                            #interlocutor>
                                                    </div>
                                                    <div class="input-group col-md-7" style="margin-left:-2px">

                                                        <input type="text"
                                                            class="focus-input input_border focus-input input_border form-control   col-md-10 tsiInput"
                                                            name="codInterlocutor" [(ngModel)]="objCliente.razonc"
                                                            [disabled]="disabledInterlocutor" tabindex="6" #razon
                                                            (keydown.enter)="onKeyEnterInterlocutor($event)">


                                                        <div class="input-group-append " style="width:40px">
                                                            <button *ngIf="buscarLimpiarBoton == 'buscar' "
                                                                class="btn btn-primary btn-sm boton"
                                                                (click)="openModalInterlocutor()" type="button"
                                                                tabindex="7"><i class="fa fa-search"></i></button>
                                                            <button *ngIf="buscarLimpiarBoton == 'borrar'"
                                                                class="btn btn-primary btn-sm boton"
                                                                (click)="borrarDatosInterlocutor()" type="button"
                                                                tabindex="7"><i class="fa fa-times"></i></button>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label class="col-md-2 label-size tsiLabel mt-2">Tipo de
                                                        persona:
                                                    </label>
                                                    <div class="col-sm-2">
                                                        <select [disabled]="encontro"
                                                            class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                                            (change)="onSelectTipoPersonaIns($event.target.value)"
                                                            id="codtpe" name="codtpe" [(ngModel)]="objCliente.codtpe"
                                                            #selectInsertar tabindex="1">
                                                            <option *ngFor="let lst of tipopersona"
                                                                value="{{lst.codtpe}}">
                                                                {{lst.destpe}}</option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>

                                                    <label class="col-md-2 label-size tsiLabel mt-2">Ingreso:
                                                    </label>
                                                    <div class="col-sm-2">
                                                        <input disabled type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.fecing" name="fecing" maxlength="3">
                                                    </div>
                                                    <div class="col-sm-3" style="margin-left: 2em;">
                                                        <input [disabled]="encontro" type="checkbox"
                                                            class="form-check-input" id="exampleCheck1"
                                                            [(ngModel)]="objCliente.valident" name="valident">
                                                        <label class="tsiLabel form-check-label ajuste-check-label"
                                                            for="exampleCheck1">Valida
                                                            identidad</label>
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label class="col-md-2 label-size tsiLabel mt-2">Tipo de
                                                        identidad:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <select [disabled]="encontro"
                                                            class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                                            id="tident"
                                                            (change)="onSelectTipoIdentidadIns($event.target.value)"
                                                            name="tident" [(ngModel)]="objCliente.tident" tabindex="4">
                                                            <option *ngFor="let tipdoci of identidades ;"
                                                                value="{{tipdoci.tident}}">
                                                                {{tipdoci.descri}}</option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>

                                                    <label class="col-md-2 label-size tsiLabel mt-2"
                                                        style="margin-left: -17px">Doc. de identidad:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            [disabled]="encontro" type="text"
                                                            (blur)="onBlurDocIdentidad()"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.dident" name="dident" #dident
                                                            [maxlength]="tamanoidentidad" tabindex="5">
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label class="col-md-2 label-size tsiLabel mt-2">Código:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="disable_codigo" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.codcli" name="codcli" maxlength="20"
                                                            tabindex="6" disabled>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>

                                                <div *ngIf="tident=='06'">
                                                    <div class="form-group row d-flex align-items-center"
                                                        style="margin-bottom: 0px">
                                                        <label for="fname2"
                                                            class="col-md-2 label-size tsiLabel mt-2">Apellidos
                                                            y
                                                            nombres:
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <input [disabled]="encontro" type="text"
                                                                class="focus-input input_border form-control  tsiInput"
                                                                [(ngModel)]="objCliente.razonc"
                                                                (keyup)="onKeyUpNombresCompletos($event)" name="razonc"
                                                                maxlength="80" tabindex="7">
                                                        </div>
                                                        <span
                                                            style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                    </div>
                                                </div>
                                                <div *ngIf="tident!='06'">
                                                    <div class="form-group row d-flex align-items-center"
                                                        style="margin-bottom: 0px">
                                                        <label for="fname2"
                                                            class="col-md-2 label-size tsiLabel mt-2">Razón
                                                            social:
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <input [disabled]="encontro" type="text"
                                                                class="focus-input input_border form-control  tsiInput"
                                                                [(ngModel)]="objCliente.razonc" name="razonc"
                                                                maxlength="100" tabindex="7">
                                                        </div>
                                                        <span
                                                            style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                    </div>
                                                </div>

                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Dirección 1:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.direc1" name="direc1"
                                                            maxlength="100" tabindex="8">
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Dirección
                                                        2:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.direc2" name="direc2"
                                                            maxlength="100" tabindex="9">
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Apellido
                                                        paterno:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.apellidopaterno"
                                                            name="apellidopaterno" maxlength="15" tabindex="10">
                                                    </div>

                                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Correo
                                                        electrónico:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.email" name="email" maxlength="50"
                                                            tabindex="11">
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Apellido
                                                        materno:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.apeliidomaterno"
                                                            name="apeliidomaterno" maxlength="15" tabindex="12">
                                                    </div>

                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Teléfono:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.telefono" name="telefono"
                                                            maxlength="30" tabindex="13">
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Nombres:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.nombres" name="nombres"
                                                            maxlength="30" tabindex="14">
                                                    </div>

                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Celular:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.fax" name="fax" maxlength="30"
                                                            tabindex="15">
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">DNI:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input [disabled]="encontro" [disabled]="identidad" type="text"
                                                            class="focus-input input_border form-control  tsiInput"
                                                            [(ngModel)]="objCliente.nrodni" name="nrodni" maxlength="15"
                                                            tabindex="16"
                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Sexo:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <select [disabled]="encontro" tabindex="17"
                                                            class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                                            id="sexo" name="sexo" [(ngModel)]="objCliente.sexo">
                                                            <option value="M">Masculino</option>
                                                            <option value="F">Femenino</option>
                                                        </select>
                                                    </div>


                                                </div>

                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Vendedor:
                                                    </label>
                                                    <div class="col-sm-4">
                                                        <select [disabled]="encontro"
                                                            class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                                            id="objCliente.codven" name="objCliente.codven"
                                                            [(ngModel)]="objCliente.codven" tabindex="18">
                                                            <option *ngFor="let vend of vendedor ;"
                                                                value="{{vend.codven}}">
                                                                {{vend.descven}}</option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>

                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">

                                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Título
                                                        de
                                                        lista:
                                                    </label>
                                                    <div class="col-sm-4">
                                                        <select [disabled]="encontro"
                                                            class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                                            id="objCliente.codtit" name="objCliente.codtit"
                                                            [(ngModel)]="objCliente.codtit" tabindex="19">
                                                            <option *ngFor="let tit of titulolista ;"
                                                                value="{{tit.codtit}}">
                                                                {{tit.titulo}}</option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>

                                                </div>

                                                <div class="form-group row d-flex align-items-center">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Concepto
                                                        impositivo:
                                                    </label>
                                                    <div class="col-sm-5">
                                                        <select [disabled]="encontro"
                                                            class="col-sm-12 focus-input input_border  select_border tsiSelect "
                                                            id="objCliente.regret" name="objCliente.regret"
                                                            [(ngModel)]="objCliente.regret" tabindex="20">
                                                            <option *ngFor="let lst of clienteRegimenes ;"
                                                                value="{{lst.codigo}}">
                                                                {{lst.descri}}</option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>

                                                <div class="form-group row d-flex" style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Observación:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <textarea [disabled]="encontro"
                                                            class="focus-input input_border form-control  form-control-sm select_border ajuste-textarea"
                                                            id="observ" name="observ" [(ngModel)]="objCliente.observ"
                                                            style="text-transform:uppercase;" type="text" rows="6"
                                                            maxlength="980" tabindex="21"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="form-group row mb-1 col-lg-12 justify-content-center">
                                            <label for="fname2" class=" text-left control-label col-md-3 ">Fecha
                                                creación: {{objCliente.fcreac | date:'dd/MM/yyyy'}}
                                            </label>

                                            <!-- <input  type="date" [(ngModel)]="objCliente.factua" disabled
                                                class="focus-input input_border form-control tsiInput col-sm-1"
                                               > -->

                                            <label for="fname2" class=" text-left control-label col-md-3 ">Usuario:
                                                {{objCliente.ucreac}}
                                            </label>

                                            <!--  <input  type="text" [(ngModel)]="objCliente.ucreac" disabled
                                                class="focus-input input_border form-control  tsiInput col-sm-2"> -->

                                            <label for="fname2" class=" text-left control-label col-md-3">Fecha
                                                Actualización: {{objCliente.factua | date:'dd/MM/yyyy'}}
                                            </label>

                                            <!--  <input  type="date"  [(ngModel)]="objCliente.fcreac" disabled
                                                class="focus-input input_border form-control  tsiInput col-sm-1"> -->

                                            <label for="fname2" class=" text-left control-label col-md-3">Usuario:
                                                {{objCliente.uactua}}
                                            </label>
                                            <!-- <input  type="text" [(ngModel)]="objCliente.uactua" disabled
                                                class="focus-input input_border form-control  tsiInput col-sm-2"> -->
                                        </div>
                                    </div>
                                </ng-template>

                            </ngb-tab>

                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Clases</b></ng-template>
                                <ng-template ngbTabContent>
                                    <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                                        (click)="addClase()"><i class="fa fa-plus"></i> Nuevo </button>

                                    <button [disabled]="Ubigeobloc" type="button" class="btn btn-rounded btn-success"
                                        style="margin-top: 20px" (click)="addUbigeo()"><i class="fa fa-plus"></i> Ubigeo
                                    </button>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered table-hover"
                                            style="margin-top: 30px">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Clase</th>
                                                    <th>Descripción</th>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of clases">
                                                    <td scope="row"
                                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                        <div class="btn-group btn-group-xs" role="group"
                                                            style="margin: 0px;padding: 0px;"><button type="button"
                                                                class="btn btn-sm" style="border: none; outline: none;"
                                                                (click)="open2(content2 , item)"><span
                                                                    class="fas fa-pencil-alt"
                                                                    aria-hidden="true"></span></button>

                                                            <button type="button" class="btn btn-sm "
                                                                style="border: none; outline: none;"
                                                                (click)="EliminarClase(item)"><span
                                                                    class="fas fa-trash-alt"
                                                                    aria-hidden="true"></span></button>
                                                        </div>
                                                    </td>
                                                    <td scope="row">{{ item.clase }}</td>
                                                    <td style="white-space: nowrap;">{{ item.desclase }}</td>
                                                    <td scope="row">{{ item.codigo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descodigo }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>

                                <ng-template ngbTabTitle><b>Créditos</b></ng-template>
                                <ng-template ngbTabContent>
                                    <form autocomplete="off">
                                        <div class="row px-4" style="margin-top: 20px">
                                            <div class=" col-md-4 m-r-10">
                                                <div class="form-group row">
                                                    <label for="fname2"
                                                        class="col-md-3 control-label col-form-label">Crédito</label>
                                                    <div class="col-md-6">
                                                        <div class="check-list">
                                                            <label class="ui-radio">
                                                                <input type="radio" value="0"
                                                                    [(ngModel)]="objCliente.credito" name="codpag">
                                                                <span class="input-span"></span> 0-Cerrado
                                                            </label>
                                                            <br>
                                                            <label class="ui-radio">
                                                                <input type="radio" value="1"
                                                                    [(ngModel)]="objCliente.credito" name="codpag">
                                                                <span class="input-span"></span> 1-Abierto
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class=" col-md-7">
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label class="col-md-4 label-size tsiLabel mt-2">Límite
                                                        de crédito
                                                        {{ _monedaFactor }}:
                                                    </label>
                                                    <div class="col-md-3">
                                                        <input type="text"
                                                            class="focus-input input_border form-control  tsiInput text-right"
                                                            [(ngModel)]="viewlimiteCredito" id="viewlimiteCredito"
                                                            name="viewlimiteCredito" maxlength="7" tabindex="1"
                                                            (blur)="decimalFormatLimiteCredito(viewlimiteCredito)"
                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                    </div>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label class="col-md-4 label-size tsiLabel mt-2">Días
                                                        de gracia:</label>
                                                    <div class="col-md-3">
                                                        <input type="text"
                                                            class="focus-input input_border form-control  tsiInput text-right"
                                                            [(ngModel)]="objCliente.diasgracia" id="diasgracia"
                                                            #descsucmod name="diasgracia" maxlength="5" tabindex="1"
                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </form>
                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>

                                <ng-template ngbTabTitle><b>Condiciones de pago</b></ng-template>
                                <ng-template ngbTabContent>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group row">
                                                <div class="col-md-3">
                                                    <button type="button" class="btn btn-rounded btn-success"
                                                        style="margin-top: 20px" (click)="open1(content3)"><i
                                                            class="fa fa-plus"></i> Nuevo
                                                    </button>
                                                    <!-- <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="open1(content3)"><i
                                            class="fa fa-plus"></i> Ubigeo </button> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered table-hover"
                                            style="margin-top: 16px">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                    <th>Usuario</th>
                                                    <th>Predeterminado</th>
                                                    <th>Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of condicionesPago">
                                                    <td scope="row"
                                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                        <div class="btn-group btn-group-xs" role="group"
                                                            style="margin: 0px;padding: 0px;"><button type="button"
                                                                class="btn btn-sm" style="border: none; outline: none;"
                                                                (click)="open4(content4 , item)"><span
                                                                    class="fas fa-pencil-alt"
                                                                    aria-hidden="true"></span></button>
                                                            <button type="button" class="btn btn-sm "
                                                                style="border: none; outline: none;"
                                                                (click)="EliminarCodPago(item)"><span
                                                                    class="fas fa-trash-alt"
                                                                    aria-hidden="true"></span></button>
                                                        </div>
                                                    </td>
                                                    <td scope="row">{{ item.codpag }}</td>
                                                    <td style="white-space: nowrap;">{{ item.despag }}</td>
                                                    <td scope="row">{{ item.usuari }}</td>
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.predeterminado"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                        <div style="text-align: center;" *ngIf="!item.predeterminado">
                                                            <i class="fas fa-times fa-lg" style="color: red;"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.activo"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                        <div style="text-align: center;" *ngIf="!item.activo"> <i
                                                                class="fas fa-times fa-lg" style="color: red;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>

                                <ng-template ngbTabTitle><b>Contactos</b></ng-template>
                                <ng-template ngbTabContent>
                                    <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                                        (click)="_mNuevoContacto()"><i class="fa fa-plus"></i> Nuevo </button>


                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered table-hover"
                                            style="margin-top: 30px">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Código</th>
                                                    <th>Contacto</th>
                                                    <th>Cargo</th>
                                                    <th>Email</th>
                                                    <th>Teléfono</th>
                                                    <th>Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of contactos">
                                                    <td scope="row"
                                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                        <div class="btn-group btn-group-xs" role="group"
                                                            style="margin: 0px;padding: 0px;"><button type="button"
                                                                class="btn btn-sm" style="border: none; outline: none;"
                                                                (click)="_mEditarContacto(item)"><span
                                                                    class="fas fa-pencil-alt"
                                                                    aria-hidden="true"></span></button>
                                                            <button type="button" class="btn btn-sm "
                                                                style="border: none; outline: none;"
                                                                (click)="EliminarContacto(item)"><span
                                                                    class="fas fa-trash-alt"
                                                                    aria-hidden="true"></span></button>
                                                        </div>
                                                    </td>
                                                    <td scope="row">{{ item.codcont }}</td>
                                                    <td style="white-space: nowrap;">{{ item.nomcont }}</td>
                                                    <td style="white-space: nowrap;">{{ item.cargo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.correo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.telefono }}</td>
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.activo"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                        <div style="text-align: center;" *ngIf="!item.activo"> <i
                                                                class="fas fa-times fa-lg" style="color: red;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>

                            </ngb-tab>
                            <!-- <ngb-tab *ngIf=mostrar>
                            <ng-template ngbTabTitle><b>Especificaciones</b></ng-template>
                            <ng-template ngbTabContent>
                                <hr>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group row">
                                            <div class="col-md-3">
                                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                                    (click)="open1(content7)"><i class="fa fa-plus"></i> Nuevo </button>
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Código</th>
                                                <th>Descripción</th>
                                                <th>V. Decimal</th>
                                                <th>V. Cadena</th>
                                                <th>V. Caracter</th>
                                                <th>V. Fecha</th>
                                                <th>V. Entero</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of especificaciones">
                                                <td scope="row"
                                                    style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                    <div class="btn-group btn-group-xs" role="group"
                                                        style="margin: 0px;padding: 0px;"><button type="button"
                                                            class="btn btn-sm"
                                                            (click)="AbrirModificarEspecificacion(content8 , item)"><span
                                                                class="fas fa-pencil-alt"
                                                                aria-hidden="true"></span></button>
                                                        <button type="button" class="btn btn-sm "
                                                            (click)="EliminarEspecificacion(item)"><span
                                                                class="fas fa-trash-alt"
                                                                aria-hidden="true"></span></button>
                                                    </div>
                                                </td>
                                                <td scope="row">{{ item.codesp }}</td>
                                                <td style="white-space: nowrap;">{{ item.descri }}</td>
                                                <td style="white-space: nowrap;">{{ item.vreal }}</td>
                                                <td style="white-space: nowrap;">{{ item.vstrg }}</td>
                                                <td style="white-space: nowrap;">{{ item.vchar }}</td>
                                                <td style="white-space: nowrap;">{{ item.vdate }}</td>
                                                <td style="white-space: nowrap;">{{ item.ventero }}</td>

                                                <td>
                                                    <div style="text-align: center;" *ngIf="item.activo == true"> <i
                                                            class="fas fa-check fa-lg" style="color: green;"></i></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </ng-template>
                        </ngb-tab> -->
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Direcciones de envío</b></ng-template>
                                <ng-template ngbTabContent>
                                    <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                                        (click)="nuevoDireccionEnvio()"><i class="fa fa-plus"></i> Nuevo </button>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered table-hover"
                                            style="margin-top: 30px">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Código</th>
                                                    <th>Almacén</th>
                                                    <th>Dirección 1</th>
                                                    <th>Dirección 2</th>
                                                    <th>Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of direcciones">
                                                    <td scope="row"
                                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                        <div class="btn-group btn-group-xs" role="group"
                                                            style="margin: 0px;padding: 0px;"><button type="button"
                                                                class="btn btn-sm" style="border: none; outline: none;"
                                                                (click)="editarDireccionEnvio(item)"><span
                                                                    class="fas fa-pencil-alt"
                                                                    aria-hidden="true"></span></button>
                                                            <button type="button" class="btn btn-sm "
                                                                style="border: none; outline: none;"
                                                                (click)="EliminarDireccion(item)"><span
                                                                    class="fas fa-trash-alt"
                                                                    aria-hidden="true"></span></button>
                                                        </div>
                                                    </td>
                                                    <td scope="row">{{ item.codenv }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descri }}</td>
                                                    <td style="white-space: nowrap;">{{ item.direc1 }}</td>
                                                    <td style="white-space: nowrap;">{{ item.direc2 }}</td>
                                                    <!-- <td style="white-space: nowrap;">{{ item.telefono }}</td> -->
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.swacti == 'S'"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                        <div style="text-align: center;" *ngIf="item.swacti!='S'"> <i
                                                                class="fas fa-times fa-lg" style="color: red;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Bancos</b></ng-template>
                                <ng-template ngbTabContent>
                                    <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                                        (click)="open1(content11)"><i class="fa fa-plus"></i> Nuevo </button>


                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered table-hover"
                                            style="margin-top: 30px">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Entidad Financiera</th>
                                                    <th>Tipo Cuenta EEFF</th>
                                                    <th>Moneda</th>
                                                    <th>Cuenta</th>
                                                    <!-- <th class="text-center">Activo</th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of bancos">
                                                    <td scope="row"
                                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                                        <div class="btn-group btn-group-xs" role="group"
                                                            style="margin: 0px;padding: 0px;"><button type="button"
                                                                class="btn btn-sm" style="border: none; outline: none;"
                                                                (click)="AbrirModificarBanco(content12 , item)"><span
                                                                    class="fas fa-pencil-alt"
                                                                    aria-hidden="true"></span></button>
                                                            <button type="button" class="btn btn-sm "
                                                                style="border: none; outline: none;"
                                                                (click)="EliminarBanco(item)"><span
                                                                    class="fas fa-trash-alt"
                                                                    aria-hidden="true"></span></button>
                                                        </div>
                                                    </td>
                                                    <td style="white-space: nowrap;">{{ item.desban }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descta }}</td>
                                                    <td style="white-space: nowrap;">{{ item.tipmon }}</td>
                                                    <td style="white-space: nowrap;">{{ item.cuenta }}</td>
                                                    <!-- <td>
                          <div style="text-align: center;" *ngIf="item.activo == true"> <i class="fas fa-check fa-lg"
                              style="color: green;"></i></div>
                        </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle> <span>Adjuntos</span></ng-template>
                                <ng-template ngbTabContent>
                                    <div class="col-md-12">
                                        <!-- <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button" id="loadFileXml" value="loadXml"
                                    onclick="document.getElementById('file').click();"><i class="fas fa-upload"
                                        style="margin-right: .3rem"></i> Importar documento</button> -->
                                        <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button"
                                            style="margin-top: 20px" id="loadFile" value="load"
                                            onclick="document.getElementById('file2').click();"><i class="fas fa-upload"
                                                style="margin-right: .3rem"></i> Importar archivo</button>
                                        <input type="file" style="display:none;" id="file2" name="file2"
                                            accept=".jpg,.pdf,.xml,.xlsx,.xlsm" multiple
                                            (change)="handleFileInput($event.target.files)"
                                            (click)="onInputClick($event)" />

                                        <!-- <input  #fileUpload type="file" id="file" accept=".jpg,.pdf"
                                                        (change)="uploadImage($event)">
            
                                                                                    
                                        <button [disabled]="boolguardar" class="btn btn-rounded btn-info m-b-15" (click)="agregarImagen()"
                                        style="width: 115px; margin-right: 50px; margin-top: 10px;"
                                        tabindex="14"><i
                                            class="fa fa-save"></i>&nbsp; Guardar</button> -->
                                        <br>
                                        <br>

                                        <!-- <input type="text" placeholder="Buscar ..." class="form-control col-md-6" (keydown)="onChange($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm"> -->
                                        <div class="table-responsive" style="height: 55vh;">
                                            <table class="table table-sm table-striped table-bordered table-hover"
                                                style="margin-top: 10px">
                                                <thead>
                                                    <tr>
                                                        <th class="text-center"></th>
                                                        <th>Item</th>
                                                        <th>Formato</th>
                                                        <th>Nombre</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="cursor" *ngFor="let lst of doc_adjuntos">
                                                        <td style="text-align: center;">
                                                            <div class="btn-group dropright" ngbDropdown
                                                                container="body" role="group"
                                                                aria-label="Button group with nested dropdown"
                                                                style="margin: 0px; padding: 0px;">
                                                                <button class="btn btn-sm" ngbDropdownToggle
                                                                    style="margin: 0px; padding: 0px;">
                                                                    <i class=" fas fa-align-left"></i>
                                                                </button>
                                                                <ul class="dropdown-menu" ngbDropdownMenu>
                                                                    <li>
                                                                        <a class="dropdown-item" href="javascript:;"
                                                                            style="width: 84%;"
                                                                            (click)="eliminarAdj(lst)">
                                                                            <i style="width: 84%;"
                                                                                class="fas fa-trash-alt"
                                                                                style="margin-right: .3rem"></i>Eliminar</a>
                                                                    </li>
                                                                    <li>
                                                                        <a class="dropdown-item" href="javascript:;"
                                                                            style="width: 84%;"
                                                                            (click)="descargarAdj(lst)">
                                                                            <i style="width: 84%;"
                                                                                class="fas fa-download"
                                                                                style="margin-right: .3rem"></i>Descargar</a>
                                                                    </li>

                                                                </ul>
                                                            </div>
                                                        </td>
                                                        <!--      <td style="white-space: nowrap;" class="text-left">{{lst.item}}</td> -->
                                                        <td style="white-space: nowrap;" class="text-left">{{lst.id}}
                                                        </td>
                                                        <td style="white-space: nowrap;" class="text-left">
                                                            {{lst.formato}}
                                                        </td>
                                                        <td style="white-space: nowrap;" class="text-left">
                                                            {{lst.nombre}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngb-tab>
                        </ngb-tabset>

                        <!-- Nueva Clase-->
                        <ng-template #content1 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nueva clase:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Clase:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            [(ngModel)]="codClase" name="codClase" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            [(ngModel)]="codClase"
                                                            (change)="onChangeClases($event.target.value)"
                                                            name="codClase" #selectClase>
                                                            <option *ngFor="let claseSele of listaclases"
                                                                value="{{claseSele.codigo}}">
                                                                {{claseSele.codigo+' - '+claseSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Código:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            [(ngModel)]="codCodigoClase" name="codCodigoClase"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3">
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select [disabled]="disabledCodigosClaseCombo" tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            [(ngModel)]="codCodigoClase" name="codCodigoClase"
                                                            #selectClase>
                                                            <option *ngFor="let codigoSele of listacodigos"
                                                                value="{{codigoSele.codigo}}">
                                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <!-- <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarClase();" tabindex="5"><i
                  class="fa fa-save"></i>Guardar</button>
                   -->
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="guardarClase()" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar </button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>
                            </div>
                        </ng-template>
                        <!-- Modifica Clase-->
                        <ng-template #content2 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar clase</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-4">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px"> <!---->
                                                    <!---->
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Clase:</label>

                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control tsiInput"
                                                            [(ngModel)]="editinputcla" name="editinputcla" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select disabled tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            [(ngModel)]="editinputcla" name="editinputcla" #selectClase>
                                                            <option *ngFor="let claseSele of listaclases"
                                                                value="{{claseSele.codigo}}">
                                                                {{claseSele.codigo+' - '+claseSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px"> <!---->
                                                    <!---->
                                                    <label for="fname2"
                                                        class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                                                    <div class="col-md-2">
                                                        <input disabled style="text-align: center"
                                                            class="form-control tsiInput" [(ngModel)]="editinputcodigo"
                                                            name="editinputcodigo" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3">
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            [(ngModel)]="editinputcodigo" name="editinputcodigo"
                                                            #selectClase>
                                                            <option *ngFor="let codigoSele of listacodigos"
                                                                value="{{codigoSele.codigo}}">
                                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success"
                                    (click)="guardarActualizarClase();" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Nueva Condicion de Pago-->
                        <ng-template #content3 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nueva condición de pago</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-4">
                                <form>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Cond.
                                                        pago:
                                                    </label>
                                                    <div class="col-md-1">
                                                        <input style="text-align: center;" class="form-control tsiInput"
                                                            [(ngModel)]="codCondicionPago" name="codCondicionPago"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <select tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            [(ngModel)]="codCondicionPago" name="codCondicionPago"
                                                            #selectClase style="color: black;">
                                                            <option *ngFor="let claseSele of listacondpago"
                                                                value="{{claseSele.codpag}}">
                                                                {{claseSele.codpag+' - '+claseSele.despag}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>

                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px">
                                                    <label for="fname2"
                                                        class=" col-md-3 control-label col-form-label"></label>

                                                    <label class="ui-checkbox mt-2">
                                                        <input type="checkbox"
                                                            (change)="onChangePredeterminado($event.target.checked)"
                                                            [checked]="predeterminado" id="predeterminado"
                                                            tabindex="302">
                                                        <span class="input-span ml-2">Predeterminado</span>
                                                    </label>
                                                    <app-custom-switch [(valor)]="activo    " [identificador]="'1'"
                                                        style="margin-left: -14px;"></app-custom-switch>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success" (click)="nuevaCondicionPago()"
                                    tabindex="5"><i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Modificar Condicion de Pago-->
                        <ng-template #content4 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar condición de pago</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-4">
                                <form>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px"> <!---->

                                                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Cond.
                                                        pago:
                                                    </label>
                                                    <div class="col-md-1">
                                                        <input disabled style="text-align: center;"
                                                            class="form-control tsiInput"
                                                            [(ngModel)]="codCondicionPagoUpd" name="codCondicionPagoUpd"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select disabled tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            style="color: black;" [(ngModel)]="codCondicionPagoUpd"
                                                            name="codCondicionPagoUpd   " #selectClase>
                                                            <option *ngFor="let claseSele of listacondpago"
                                                                value="{{claseSele.codpag}}">
                                                                {{claseSele.codpag+' - '+claseSele.despag}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span
                                                        style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                                                </div>

                                                <div class="form-group row d-flex align-items-center"
                                                    style="margin-bottom: 0px"> <label for="fname2"
                                                        class=" col-md-3 control-label col-form-label"></label>
                                                    <label class="ui-checkbox mt-2">
                                                        <input type="checkbox"
                                                            (change)="onChangePredeterminadoUpd($event.target.checked)"
                                                            [checked]="predeterminadoUpd" id="predeterminadoUpd"
                                                            tabindex="302">
                                                        <span class="input-span ml-2">Predeterminado</span>
                                                    </label>

                                                    <app-custom-switch [(valor)]="activoUpd" [identificador]="'2'"
                                                        style="margin-left: -14px;"></app-custom-switch>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success"
                                    (click)="guardarActualizarCondicion()" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Nuevo Contacto-->


                        <!-- Nueva Especificación-->
                        <ng-template #content7 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nueva Especificación:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div *ngIf="tipoConfirmar == 'Insert'" class="modal-body" id="first">
                                                    <h5 class="modal-title pull-left">Visualización de especificaciones
                                                    </h5>
                                                    <div class="form-row col-md-12">
                                                        <table
                                                            class="table table-striped display nowrap dataTable no-footer"
                                                            id="datatableEspecificaciones" cellspacing="0" width="100%">
                                                            <thead>
                                                                <tr>
                                                                    <th>Código</th>
                                                                    <th>Especificación</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let lst of especificacion"
                                                                    (click)="onCLickEspecificacion(lst)">
                                                                    <td>{{lst.codigo}}</td>
                                                                    <td>{{lst.descri}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div *ngIf="tipoConfirmar == 'InsertEspecificacion'" class="modal-body"
                                                    id="first">
                                                    <form action="" #form="ngForm" autocomplete="off">
                                                        <div *ngIf="disabledDecimal == true" class="input-group">
                                                            <label style="margin-right: .6em">Decimal</label>
                                                            <input
                                                                class="col-md-3 focus-input input_border form-control  form-control-sm m-r-5"
                                                                id="decimal" name="decimal" [(ngModel)]="decimal"
                                                                type="number" maxlength="5" style="margin-right: .5rem"
                                                                onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                        </div>

                                                        <div *ngIf="disabledTexto == true" class="input-group">
                                                            <label style="margin-right: 1.8rem">Texto</label>
                                                            <input
                                                                class="focus-input input_border form-control  form-control-sm"
                                                                id="texto" name="texto" [(ngModel)]="texto" type="text"
                                                                style="text-transform:uppercase;">
                                                        </div>

                                                        <div *ngIf="disabledCaracter == true" class="input-group">
                                                            <label style="margin-right: .5rem">Caracter</label>
                                                            <input
                                                                class="focus-input input_border form-control  form-control-sm col-md-2"
                                                                id="caracter" name="caracter" [(ngModel)]="caracter"
                                                                type="text" style="text-transform:uppercase;">
                                                        </div>

                                                        <div *ngIf="disabledFecha == true" class="input-group">
                                                            <label style="margin-right: 1.75rem">Fecha</label>
                                                            <input
                                                                class="focus-input input_border form-control  form-control-sm col-md-4"
                                                                id="fecha" name="fecha" [(ngModel)]="fecha" type="date"
                                                                max="2999-01-01">
                                                        </div>

                                                        <div *ngIf="disabledTiempo == true" class="input-group">
                                                            <label style="margin-right: 1rem">Tiempo</label>
                                                            <input
                                                                class="focus-input input_border form-control  form-control-sm col-md-2"
                                                                id="tiempo" name="tiempo" [(ngModel)]="tiempo"
                                                                type="time" style="text-transform:uppercase;">
                                                        </div>

                                                        <div *ngIf="disabledNumero == true" class="input-group">
                                                            <label style="margin-right: .7rem">Número</label>
                                                            <input
                                                                class="focus-input input_border form-control  form-control-sm col-md-2"
                                                                id="numero" name="numero" [(ngModel)]="numero"
                                                                type="text" style="text-transform:uppercase;">
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="guardarEspecificacion();" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Modificar Especificación -->
                        <ng-template #content8 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar Especificación:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 class="modal-title pull-left"></h5>
                                                <div class="form-row col-md-12">
                                                    <table
                                                        class="table table-striped display nowrap dataTable no-footer"
                                                        id="datatableEspecificaciones" cellspacing="0" width="100%">
                                                        <thead>
                                                            <tr>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <div>
                                                                <h5 class="modal-title pull-left">
                                                                    {{desEspecificacionUpd}}
                                                                </h5>
                                                                <br>
                                                            </div>
                                                            <div>
                                                                <form action="" #form="ngForm" autocomplete="off">
                                                                    <div *ngIf="disabledDecimalUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: .6em">Decimal</label>
                                                                        <input
                                                                            class="col-md-3 focus-input input_border form-control  form-control-sm m-r-5"
                                                                            id="decimalUpd" name="decimalUpd"
                                                                            [(ngModel)]="decimalUpd" maxlength="5"
                                                                            type="text" style="margin-right: .5rem"
                                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                                    </div>

                                                                    <div *ngIf="disabledTextoUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: 1.8rem">Texto</label>
                                                                        <input
                                                                            class="focus-input input_border form-control  form-control-sm"
                                                                            id="textoUpd" name="textoUpd"
                                                                            [(ngModel)]="textoUpd" type="text"
                                                                            style="text-transform:uppercase;">
                                                                    </div>

                                                                    <div *ngIf="disabledCaracterUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: .5rem">Caracter</label>
                                                                        <input
                                                                            class="focus-input input_border form-control  form-control-sm col-md-2"
                                                                            id="caracterUpd" name="caracterUpd"
                                                                            [(ngModel)]="caracterUpd" type="text"
                                                                            style="text-transform:uppercase;">
                                                                    </div>

                                                                    <div *ngIf="disabledFechaUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: 1.75rem">Fecha</label>
                                                                        <input
                                                                            class="focus-input input_border form-control  form-control-sm col-md-4"
                                                                            id="fechaUpd" name="fechaUpd"
                                                                            [(ngModel)]="fechaUpd" type="date"
                                                                            max="2999-01-01">
                                                                    </div>

                                                                    <div *ngIf="disabledTiempoUpd == true"
                                                                        class="input-group">
                                                                        <label style="margin-right: 1rem">Tiempo</label>
                                                                        <input
                                                                            class="focus-input input_border form-control  form-control-sm col-md-2"
                                                                            id="tiempoUpd" name="tiempoUpd"
                                                                            [(ngModel)]="tiempoUpd" type="time"
                                                                            style="text-transform:uppercase;">
                                                                    </div>

                                                                    <div *ngIf="disabledNumeroUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: .7rem">Número</label>
                                                                        <input
                                                                            class="focus-input input_border form-control  form-control-sm col-md-2"
                                                                            id="numeroUpd" name="numeroUpd"
                                                                            [(ngModel)]="numeroUpd" type="text"
                                                                            style="text-transform:uppercase;">
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="ModificarEspecificacion();" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Nueva Direccion de Envío-->

                        <ng-template #NuevaClase let-modal>
                            <div class="modal-header">
                                <h4>Nueva clase </h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Clase:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            name="codClase" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            name="codClase" #selectClase>
                                                            <!-- <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                              {{claseSele.codigo+' - '+claseSele.descri}}
                            </option> -->
                                                            <option value="1">
                                                                Opcion01
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Código:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            name="codCodigoClase" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3">
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select [disabled]="disabledCodigosClaseCombo" tabindex="15"
                                                            class="col-md-12 focus-input input_border  select_border tsiSelect "
                                                            name="codCodigoClase" #selectClase>
                                                            <option *ngFor="let codigoSele of listacodigos"
                                                                value="{{codigoSele.codigo}}">
                                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>


                        <!-- Modificar Direccion de Envío -->
                        <ng-template #content10 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar dirección de envío:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form action="" #form="ngForm" autocomplete="off">

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Código</label>
                                        <div class="col-sm-3">
                                            <input class="focus-input input_border form-control  form-control-sm m-r-5"
                                                id="codEnvioUpd" name="codEnvioUpd" [(ngModel)]="codEnvioUpd"
                                                type="text" disabled>
                                        </div>


                                        <div style="margin-left: 15px;">
                                            <label class="ui-checkbox">
                                                <input type="checkbox" id="activoDirecEnvio"
                                                    [checked]="activoDirecEnvio"
                                                    (change)="onChangeactivoDirecEnvio($event.target.checked)"
                                                    tabindex="604">
                                                <span class="input-span"></span>
                                            </label> <label class="tsiLabel form-check-label"
                                                for="activoDirecEnvio">Activo</label>
                                        </div>

                                    </div>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label
                                            class="col-md-2 text-left control-label col-form-label">Descripción</label>
                                        <div class="col-sm-7">
                                            <input class="focus-input input_border form-control  form-control-sm"
                                                id="desEnvioUpd" name="desEnvioUpd" [(ngModel)]="desEnvioUpd"
                                                maxlength="50" type="text" tabindex="801">
                                        </div>
                                        <span style="color: red; font: sans-serif;">(*)</span>
                                    </div>


                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Dirección</label>
                                        <div class="col-sm-9">
                                            <input class="focus-input input_border form-control  form-control-sm"
                                                id="direccionE1Upd" name="direccionE1Upd" [(ngModel)]="direccionE1Upd"
                                                maxlength="120" type="text" tabindex="802">
                                        </div>

                                        <span style="color: red; font: sans-serif;">(*)</span>
                                    </div>


                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label
                                            class="col-md-2 text-left control-label col-form-label">Referencia</label>
                                        <div class="col-sm-4">
                                            <input class="focus-input input_border form-control  form-control-sm m-r-5"
                                                id="referenciaEnvioUpd" name="referenciaEnvioUpd"
                                                [(ngModel)]="referenciaEnvioUpd" maxlength="50" type="text"
                                                tabindex="803">
                                        </div>
                                    </div>



                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Código
                                            EAN</label>
                                        <div class="col-sm-4">
                                            <input class="focus-input input_border form-control  form-control-sm m-r-5"
                                                id="codEanEnvioUpd" name="codEanEnvioUpd" [(ngModel)]="codEanEnvioUpd"
                                                maxlength="30" type="text" tabindex="805">
                                        </div>
                                    </div>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Teléfono</label>
                                        <div class="col-sm-4">
                                            <input class="focus-input input_border form-control  form-control-sm"
                                                id="telefonoEnvioUpd" name="telefonoEnvioUpd"
                                                [(ngModel)]="telefonoEnvioUpd" maxlength="30" type="text"
                                                tabindex="804">
                                        </div>
                                    </div>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Celular</label>
                                        <div class="col-sm-4">
                                            <input class="focus-input input_border form-control  form-control-sm"
                                                id="celularEnvioUpd" name="celularEnvioUpd"
                                                [(ngModel)]="celularEnvioUpd" maxlength="30" type="text" tabindex="806">
                                        </div>
                                    </div>




                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success"
                                    (click)="ModificarDireccionEnvio();" tabindex="5"><i
                                        class=" fas fa-angle-double-right m-b-15"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!--Nuevo Banco-->
                        <ng-template #content11 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nuevo banco</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-3 pr-4">
                                <form action="" #form="ngForm" autocomplete="off">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label for="fname2"
                                                    class="col-md-4 label-size tsiLabel mt-2">Financiera:</label>
                                                <input class="col-md-2 focus-input input_border form-control tsiInput"
                                                    id="codBanco" name="codBanco" [(ngModel)]="codBanco" type="number"
                                                    maxlength="3" style="margin-right: 0.5rem; margin-left: -45px;"
                                                    tabindex="1000">

                                                <select
                                                    class="col-md-7 focus-input input_border  select_border tsiSelect "
                                                    id="cboBanco" name="codBanco" [(ngModel)]="codBanco"
                                                    (change)="onChangeFinanciera($event.target.value)" tabindex="1001">
                                                    <option *ngFor="let cc of financieras" value="{{cc.codigo}}">
                                                        {{cc.codigo}} - {{cc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label or="fname2" class="col-md-4 label-size tsiLabel mt-2">Tipo
                                                    cuenta:</label>
                                                <input class="col-md-2 focus-input input_border form-control tsiInput"
                                                    id="codTipoCuenta" name="codTipoCuenta" [(ngModel)]="codTipoCuenta"
                                                    type="text" maxlength="2"
                                                    style="margin-right: 0.5rem; margin-left: -33px;" tabindex="1002">

                                                <select
                                                    class="col-md-7 focus-input input_border  select_border tsiSelect "
                                                    id="cboTipoCuenta" name="codTipoCuenta" [(ngModel)]="codTipoCuenta"
                                                    (change)="onChangeTipoCuenta()" [disabled]="disabledTipoCuenta"
                                                    tabindex="1003">
                                                    <option *ngFor="let ccc of tipocuentas" value="{{ccc.codigo}}">
                                                        {{ccc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label or="fname2"
                                                    class="col-md-4 label-size tsiLabel mt-2">Moneda:</label>
                                                <input class="col-md-2 focus-input input_border form-control tsiInput"
                                                    id="codMoneda" name="codMoneda" [(ngModel)]="codMoneda" type="text"
                                                    tabindex="1004" maxlength="3"
                                                    style="margin-right: 0.5rem; margin-left: -45px;">
                                                <select
                                                    class="col-md-7 focus-input input_border  select_border tsiSelect "
                                                    id="cboMoneda" name="codMoneda" tabindex="1005"
                                                    [(ngModel)]="codMoneda" [disabled]="disabledMoneda">
                                                    <option *ngFor="let mon of monedas" value="{{mon.codmon}}">
                                                        {{mon.desmon}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label or="fname2" class="col-md-5 label-size tsiLabel mt-2">N°
                                                    cuenta:</label>
                                                <input class="col-md-11 focus-input input_border form-control tsiInput "
                                                    id="desCuenta" name="desCuenta" tabindex="1006"
                                                    [(ngModel)]="desCuenta" type="text" style="margin-left: -40px;"
                                                    maxlength="100">
                                            </div>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="guardarBanco();" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!--Modificar Banco-->
                        <ng-template #content12 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar banco</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-3 pr-4">
                                <form action="" #form="ngForm" autocomplete="off">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label for="fname2"
                                                    class="col-md-4 label-size tsiLabel mt-2">Financiera:</label>
                                                <input disabled
                                                    class="col-md-2 focus-input input_border form-control tsiInput"
                                                    id="codBancoUpd" name="codBancoUpd" [(ngModel)]="codBancoUpd"
                                                    type="number" maxlength="3" tabindex="1000"
                                                    style="margin-right: 0.5rem; margin-left: -45px;">

                                                <select disabled
                                                    class="col-md-7 focus-input input_border  select_border tsiSelect "
                                                    id="cboBanco" name="codBancoUpd" [(ngModel)]="codBancoUpd"
                                                    (change)="onChangeFinanciera($event.target.value)" tabindex="1001">
                                                    <option *ngFor="let cc of financieras" value="{{cc.codigo}}">
                                                        {{cc.descri}}</option>
                                                </select>
                                            </div>

                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label or="fname2" class="col-md-4 label-size tsiLabel mt-2">Tipo
                                                    cuenta:</label>
                                                <input class="col-md-2 focus-input input_border form-control tsiInput"
                                                    id="codTipoCuentaUpd" name="codTipoCuentaUpd"
                                                    [(ngModel)]="codTipoCuentaUpd" type="text"
                                                    style="margin-right: 0.5rem; margin-left: -33px;" maxlength="2"
                                                    tabindex="1002">

                                                <select
                                                    class="col-md-7 focus-input input_border  select_border tsiSelect "
                                                    id="cboTipoCuentaUpd" name="codTipoCuentaUpd"
                                                    [(ngModel)]="codTipoCuentaUpd" (change)="onChangeTipoCuenta()"
                                                    disabled tabindex="1003">
                                                    <option *ngFor="let ccc of tipocuentas" value="{{ccc.codigo}}">
                                                        {{ccc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label or="fname2"
                                                    class="col-md-4 label-size tsiLabel mt-2">Moneda:</label>
                                                <input class="col-md-2 focus-input input_border form-control tsiInput"
                                                    id="codMonedaUpd" name="codMonedaUpd" [(ngModel)]="codMonedaUpd"
                                                    type="text" tabindex="1004" maxlength="3"
                                                    style="margin-right: 0.5rem; margin-left: -45px;">
                                                <select
                                                    class="col-md-7 focus-input input_border  select_border tsiSelect "
                                                    id="cboMoneda" name="codMonedaUpd" tabindex="1005"
                                                    [(ngModel)]="codMonedaUpd" disabled>
                                                    <option *ngFor="let mon of monedas" value="{{mon.codmon}}">
                                                        {{mon.desmon}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group row d-flex align-items-center"
                                                style="margin-bottom: 0px">
                                                <label or="fname2" class="col-md-5 label-size tsiLabel mt-2">N°
                                                    cuenta:</label>
                                                <input class="col-md-11 focus-input input_border form-control tsiInput "
                                                    id="desCuentaUpd" name="desCuentaUpd" tabindex="1006"
                                                    [(ngModel)]="desCuentaUpd" type="text" style="margin-left: -40px;"
                                                    maxlength="100">
                                            </div>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="modificarBanco();" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>